"use strict";

/**
 * Cостояние версии документа.
 *
 * @enum {integer} VERSION_STATE
 * @readonly
 * @since 5.0.0.4218
 * @global
 * @example
 *
 * //Установить для первой версии документа с ИД=123123 состояние «В разработке».
 * WA.SRV.document.version.setState(123123,1,VERSION_STATE.IN_DESING);
 */
var VERSION_STATE = {
  /*Cостояние по умолчанию, указанное в карточке вида документа на закладке «Жизненный цикл».*/
  DEFAULT: 0,
  /** В разработке */
  IN_DESING: 1,
  /** Действующая */
  ACTIVE: 2,
  /** Устаревшая */
  OBSOLETE: 3
};

(function (global) {

  /**
   * Предоставляет инструменты для работы с версиями документа.
   *
   * @namespace WebAccess.services.document.version
   * @since 5.0.0.4218
   */
  global.document.version = {};

  /**
   * Получает имя документа по ИД.
   *
   * @function getNameById
   * @param {Array<number>} ids ИД документа.
   * @returns {Deferred<string>} Наименование документа.
   * @see https://api.jquery.com/category/deferred-object/
   */
  global.document.getNameById = function (ids) {
    var d = $.Deferred();

    WA.SRV.call('/api/LinkQuery.asmx/GetDocumentsById', {
      ids: ids
    }, null, null, true, true).done(function (data) {
      var docs = $.parseJSON(data);
      if (docs && docs.length > 0) {
        d.resolve(docs[0].name);
      } else {
        d.reject(L('ERR_OBJECT_NOT_FOUND'));
      }
    }).fail(function (err) {
      d.reject(err);
    });

    return d.promise();
  };


  /**
   * Изменить примечание версии.
   *
   * @function WebAccess.services.document.version.setNote
   * @param {integer} docId ИД документа
   * @param {integer} verNumber Номер версии документа
   * @param {string} note Текст примечания
   * @return {deferred} Специальный deferred-объект.
   * @since 5.0.0.4218
   * @example
   *
   * //Установить для первой версии документа с ИД=123123 примечание «Для рассылки».
   * WA.SRV.document.version.setNote(123123,1,"Для рассылки");
   */
  global.document.version.setNote = function (docId, verNumber, note) {
    return global.call("/Document.asmx/ChangeVersionNote", {
      'DocumentID': docId,
      'VersionNumber': verNumber,
      'Note': note
    }, false, false);
  };


  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  /**
   * Изменить состояние версии.
   *
   * @function WebAccess.services.document.version.setState
   * @param {integer} docId ИД документа
   * @param {integer} verNumber Номер версии документа
   * @param {string} state Состояние документа. Глобальная функция VERSION_STATE
   * @return {deferred} Специальный deferred-объект.
   * @since 5.0.0.4218
   * @example
   *
   * //Установить для первой версии документа с ИД=123123 состояние «В разработке».
   * WA.SRV.document.version.setState(123123,1,VERSION_STATE.IN_DESING);
   */
  global.document.version.setState = function (docId, verNumber, state) {
    return global.call("/Document.asmx/ChangeVersionState", {
      'DocumentID': docId,
      'VersionNumber': verNumber,
      'State': state
    }, false, false);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Подписывает документ.
   *
   * @function WebAccess.services.document.sign
   * @param  {number} documentId ИД документа для подписания
   * @param  {string} cardTypeCode Код типа карточки документа
   * @param  {number} versionNumber Номер версии документа для подписания
   * @param  {number} certificateId ИД сертификата, которым будет подписан документ
   * @param  {string} pluginName Имя плагина Веб-агента для подписания
   * @param  {string} comment Комментарий к подписи
   * @param  {boolean} isApprovingSign Признак утверждающей подписи
   * @param  {boolean} isForSubstitute Признак подписания документа от имени замещаемого пользователя
   * @param  {string} substituteUserCode Код замещаемого пользователя. Параметр передается, если в параметре isForSubstitute установлено значение true
   * @param  {function} onSignedCallback Функция обратного вызова для подписания. В качестве параметра передается ответ от Веб-агента
   * @param  {string} additionalInfo Дополнительная информация о подписи документа
   * @param  {string} pluginVersion Версия плагина Веб-агента для подписания
   * @param  {string} tokenPinCode Пин-код токена, с помощью которого подписывается документ
   * @return {Deferred<Object>} Результат подписания.
   * @since 5.6.0.1000
   * @see https://api.jquery.com/category/deferred-object/
   */
  global.document.sign = function (documentId, cardTypeCode, versionNumber, certificateId, pluginName, comment, isApprovingSign,
    isForSubstitute, substituteUserCode, onSignedCallback, additionalInfo, pluginVersion, tokenPinCode) {

    var d = $.Deferred();

    global.document.onBeforeSign(documentId, cardTypeCode, versionNumber, certificateId, pluginName, comment, isApprovingSign,
      isForSubstitute, substituteUserCode, onSignedCallback, additionalInfo, pluginVersion, tokenPinCode).done(function (success, signContext) {
        if (success === true) {
          WebAccess.agent.edms.signDocument(documentId, versionNumber, certificateId, pluginName, comment, isApprovingSign,
            isForSubstitute, substituteUserCode, onSignedCallback, additionalInfo, pluginVersion, tokenPinCode).always(function (signDocResponse) {
              global.document.onAfterSign(signDocResponse, signContext).done(function (result) {
                d.resolve(result);
              }).fail(function (result) {
                d.reject(result);
              });
            });
        } else {
          d.resolve(false);
        }
      }).fail(function (result) {
        d.reject(result);
      });
    return d.promise();
  };

  /**
  * Вызывается до подписания документа.
  *
  * @function WebAccess.services.document.onBeforeSign
  * @param  {number} documentId ИД документа для подписания
  * @param  {string} cardTypeCode Код типа карточки документа
  * @param  {number} versionNumber Номер версии документа для подписания
  * @param  {number} certificateId ИД сертификата, которым будет подписан документ
  * @param  {string} pluginName Имя плагина Веб-агента для подписания
  * @param  {string} comment Комментарий к подписи
  * @param  {boolean} isApprovingSign Признак утверждающей подписи
  * @param  {boolean} isForSubstitute Признак подписания документа от имени замещаемого пользователя
  * @param  {string} substituteUserCode Код замещаемого пользователя. Параметр передается, если в параметре isForSubstitute установлено значение true
  * @param  {function} onSignedCallback Функция обратного вызова для подписания. В качестве параметра передается ответ от Веб-агента
  * @param  {string} additionalInfo Дополнительная информация о подписи документа
  * @param  {string} pluginVersion Версия плагина Веб-агента для подписания
  * @param  {string} tokenPinCode Пин-код токена, с помощью которого подписывается документ
  * @return {Deferred<boolean>} Успешность выполнения.
  * @since 5.6.0.1000
  */
  global.document.onBeforeSign = function (documentId, cardTypeCode, versionNumber, certificateId, pluginName, comment, isApprovingSign,
    isForSubstitute, substituteUserCode, onSignedCallback, additionalInfo, pluginVersion, tokenPinCode) {

    var signContext = {};
    var d = $.Deferred();
    d.resolve(true, signContext);

    return d.promise();
  };

  /**
   * Вызывается после подписания документа.
   *
   * @function WebAccess.services.document.onAfterSign
   * @param  {object} signDocResponse Результат подписания документа
   * @param  {object} signContext Данные, заполненные в функции до подписания
   * @return {Deferred<void>}
   * @since 5.6.0.1000
   * @see https://api.jquery.com/category/deferred-object/
   */
  global.document.onAfterSign = function (signDocResponse, signContext) {
    var d = $.Deferred();
    d.resolve();

    return d.promise();
  };

  /**
   * Удаляет документы.
   * @function WebAccess.services.document.deleteDocuments
   * @param  {string} folderName Идентификаторы документов.
   * @return {Deferred<Object>} Результат удаления документов.
   * @since 5.8.4.9000
   */
  global.document.deleteDocuments = documentIds => {
    let d = $.Deferred();
    WA.SRV.call('/api/Document.asmx/DeleteDocuments', { documentIds: documentIds }).done((res) => {
      d.resolve(res);
    }).fail((res) => {
      d.reject(res);
    });
    return d.promise();
  };

})(window.WebAccess.services);
